import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-015ea7d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "StereoSameEdgeRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下面是一个立方体的展开图，请你判断把它重新折叠成立方体后，判断两个箭头指向的边是否能够重合", -1));
const _hoisted_4 = {
  class: "flex justify-center mt16"
};
const _hoisted_5 = ["width", "height", "viewBox"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("marker", {
  id: "arrowA",
  markerWidth: "10",
  markerHeight: "10",
  refX: "8",
  refY: "5",
  orient: "auto"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M 0 0 L 10 5 L 0 10 z",
  fill: "#2b8bd6"
})]), /*#__PURE__*/_createElementVNode("marker", {
  id: "arrowB",
  markerWidth: "10",
  markerHeight: "10",
  refX: "8",
  refY: "5",
  orient: "auto"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M 0 0 L 10 5 L 0 10 z",
  fill: "#f07a6a"
})])], -1));
const _hoisted_7 = ["x", "y", "width", "height"];
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = ["transform"];
const _hoisted_10 = ["x1", "x2"];
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = ["transform"];
const _hoisted_13 = ["x1", "x2"];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请选择", -1));
const _hoisted_15 = {
  class: "bothCenter mt16"
};
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col mt16"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock("svg", {
    width: $options.svgW,
    height: $options.svgH,
    viewBox: `0 0 ${$options.svgW} ${$options.svgH}`,
    role: "img",
    "aria-label": "Stereo Same Edge"
  }, [_hoisted_6, _createElementVNode("g", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.netCells, cell => {
    return _openBlock(), _createElementBlock("rect", {
      key: `cell_${cell.id}`,
      x: $options.cellDraw(cell).x,
      y: $options.cellDraw(cell).y,
      width: $options.cellSize,
      height: $options.cellSize,
      fill: "#ffffff",
      stroke: "#999999",
      "stroke-width": "2",
      rx: "6",
      ry: "6"
    }, null, 8, _hoisted_7);
  }), 128))]), $options.arrowAInfo ? (_openBlock(), _createElementBlock("g", _hoisted_8, [_createElementVNode("g", {
    transform: $options.arrowTransform($options.arrowAInfo)
  }, [_createElementVNode("line", {
    x1: -$options.arrowLen / 2,
    y1: "0",
    x2: $options.arrowLen / 2,
    y2: "0",
    stroke: "#2b8bd6",
    "stroke-width": "4",
    "marker-end": "url(#arrowA)"
  }, null, 8, _hoisted_10)], 8, _hoisted_9)])) : _createCommentVNode("", true), $options.arrowBInfo ? (_openBlock(), _createElementBlock("g", _hoisted_11, [_createElementVNode("g", {
    transform: $options.arrowTransform($options.arrowBInfo)
  }, [_createElementVNode("line", {
    x1: -$options.arrowLen / 2,
    y1: "0",
    x2: $options.arrowLen / 2,
    y2: "0",
    stroke: "#f07a6a",
    "stroke-width": "4",
    "marker-end": "url(#arrowB)"
  }, null, 8, _hoisted_13)], 8, _hoisted_12)])) : _createCommentVNode("", true)], 8, _hoisted_5))]), _createVNode(_component_el_row, {
    class: "bothCenter mt24"
  }, {
    default: _withCtx(() => [_hoisted_14]),
    _: 1
  }), _createElementVNode("div", _hoisted_15, [(_openBlock(), _createBlock(_component_AnswerButtonGroup, {
    onChoose: $options.onChoosed,
    review: $props.review,
    reviewMode: $props.reviewMode,
    options: $options.options,
    "option-labels": $options.optionLabelList,
    "option-width": "160px",
    "option-both-center": false,
    key: `StereoSameEdge_${$props.data.questionIndex}`
  }, null, 8, ["onChoose", "review", "reviewMode", "options", "option-labels"]))]), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("span", null, "正确答案：" + _toDisplayString($options.labelFor($props.data.rightAnswer)), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    style: _normalizeStyle({
      color: $props.review.result ? 'green' : 'red'
    })
  }, "您的答案：" + _toDisplayString($options.labelFor($props.review.answer)), 5)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}